import { render, staticRenderFns } from "./ManageOrders.vue?vue&type=template&id=66c86f28&scoped=true"
import script from "./ManageOrders.vue?vue&type=script&lang=js"
export * from "./ManageOrders.vue?vue&type=script&lang=js"
import style0 from "./ManageOrders.vue?vue&type=style&index=0&id=66c86f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c86f28",
  null
  
)

export default component.exports